import moment from 'moment-timezone';

export {Moment, MomentInput} from 'moment-timezone';

// This should be used in favor of geomoment and node-clock extras
export default moment;
